export default "__VITE_PUBLIC_ASSET__9d2f39bf__"